import type { SchemaOf } from '../../helpers';
import { Joi, makeAllRequired } from '../../helpers';

export interface IConfig {
  beamWidthDegrees: number; // total angle: so 30 degrees would be 15 degrees on each side of beam angle
  beamAngleDegrees: number;
}

export const schemaMap: SchemaOf<IConfig> = {
  beamWidthDegrees: Joi.number(),
  beamAngleDegrees: Joi.number(),
};

export const schemaMapDefault = makeAllRequired(schemaMap);

export const defaultConfig: IConfig = {
  beamWidthDegrees: 30,
  beamAngleDegrees: 0,
};
